module.exports = __webpack_public_path__ + "static/media/IMG_0682_Reduced.af4ad500.jpg";